<template>
  <div>
    <div class="fast-modal-content">
      <Teleport to="#fast-title">Quelles sont vos attentes&nbsp;?</Teleport>
      <div class="form-group" :class="{ 'form-group-invalid': hasErrors }">
        <label for="title" class="flex justify-between font-normal text-body">
          <span>Détails de votre projet</span>
          <span>{{ 1000 - newDescription.length }}/1000</span>
        </label>
        <FastInput
          v-model="newDescription"
          :inner-class="hasErrors ? 'is-invalid' : ''"
          autofocus="autofocus"
          :maxlength="1020"
          :placeholder="`Je recherche un graphiste pour…\nMon besoin porte principalement sur la création…\nLe graphiste doit avoir des compétences en…\nLes travaux graphiques doivent être réalisés avant le…`"
          type="textarea"
          name="title"
          @keyup.meta.enter="handleNextStep"
        />
      </div>
    </div>
    <StepsNavigation :next-step-disabled="!isValid" @prevStep="handlePrevStep" @nextStep="handleNextStep" />
  </div>
</template>

<script>
import stepEvents from '../mixins/stepEvents'
import StepsNavigation from './StepsNavigation.vue'
import FastInput from '@/apps/shared/components/FastInput.vue'

export default {
  name: 'StepDescription',
  components: {
    StepsNavigation,
    FastInput
  },
  mixins: [stepEvents],
  props: {
    description: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newDescription: this.description
    }
  },
  computed: {
    isValid() {
      const valid = this.newDescription.length > 1 && this.newDescription.length <= 1000
      return valid
    },
    hasErrors() {
      return !this.isValid && this.newDescription.length > 0
    }
  },
  watch: {
    newDescription(newVal, oldVal) {
      this.$emit('attributeChange', 'description', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
textarea {
  font-size: 16px;
  border-width: 2px;
}
</style>
